module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(!_vm.isDoctor) ? _c('user-notifications', {
    model: {
      value: (_vm.confirmationRequests),
      callback: function($$v) {
        _vm.confirmationRequests = $$v
      },
      expression: "confirmationRequests"
    }
  }) : _vm._e(), _vm._v(" "), _c('coming-visit', {
    on: {
      "more": _vm.loadEvents
    },
    model: {
      value: (_vm.upcomingEvents),
      callback: function($$v) {
        _vm.upcomingEvents = $$v
      },
      expression: "upcomingEvents"
    }
  }), _vm._v(" "), _c('user-events', {
    model: {
      value: (_vm.lastEvents),
      callback: function($$v) {
        _vm.lastEvents = $$v
      },
      expression: "lastEvents"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7ce933da"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Cabinet/Cabinet/Tabs/Events.vue
// module id = 635
// module chunks = 0